import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer
      className="bg-gray-900 text-white"
      role="contentinfo"
      data-testid="footer"
    >
      <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Column */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/images/brand/ask-mi-logo-clean.webp" 
                alt="asK-mi" 
                className="h-12 w-auto"
              />
              <span className="text-xl font-semibold">asK-mi</span>
            </div>
            <p className="text-sm text-white/60 italic mb-5">
              „Weil der Mensch den Menschen braucht."
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://www.instagram.com/ask_stiftung/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/50 hover:text-[#C4A962] transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/company/ask-mi" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-white/50 hover:text-[#C4A962] transition-colors"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Organisation */}
          <div>
            <h3 className="text-xs font-semibold text-[#C4A962] uppercase tracking-wider mb-5">
              Organisation
            </h3>
            <ul className="space-y-3">
              <li><Link to="/was-wir-tun" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Was wir tun</Link></li>
              <li><Link to="/foerdern" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Fördern</Link></li>
              <li><Link to="/selbsthilfe" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Selbsthilfe</Link></li>
              <li><Link to="/transparenz" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Transparenz</Link></li>
              <li><Link to="/ueber-uns" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Über uns</Link></li>
            </ul>
          </div>

          {/* Wissen */}
          <div>
            <h3 className="text-xs font-semibold text-[#C4A962] uppercase tracking-wider mb-5">
              Wissen
            </h3>
            <ul className="space-y-3">
              <li><Link to="/wissen" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Neurodiversität</Link></li>
              <li><Link to="/wissen" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">ADS / ADHS</Link></li>
              <li><Link to="/wissen" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Autismus</Link></li>
              <li><Link to="/wissen" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Forschung</Link></li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h3 className="text-xs font-semibold text-[#C4A962] uppercase tracking-wider mb-5">
              Rechtliches
            </h3>
            <ul className="space-y-3">
              <li><Link to="/impressum" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Datenschutz</Link></li>
              <li><Link to="/kontakt" className="text-sm text-white/60 hover:text-[#C4A962] transition-colors">Kontakt</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} asK-mi · Kompetenzzentrum für menschliche Intelligenz
          </p>
          <p className="text-xs text-white/40">
            Mit Verantwortung für die nächste Generation.
          </p>
        </div>
      </div>
    </footer>
  );
}
